import { useEffect, useState } from "react";
import { fetchReferences, searchReferences } from "../../api/application/reference";
import type { PaginationOptions } from "../../api/domain/pagination";
import type { Reference } from "../../api/infrastructure/reference.formatter";
import { apiRequestWrapper } from "../../api/shared/http-client";

export default function useGetReferences({ preloadData = true }: { preloadData?: boolean } = {}) {
  const [references, setReferences] = useState<Reference[]>([]);
  const [loading, setLoading] = useState(false);

  const fetch = async (options: PaginationOptions) => {
    setLoading(true);
    await apiRequestWrapper(async () => {
      const result = await fetchReferences(options);
      setReferences(result);
    });
    setLoading(false);
  };

  const search = async (query: string) => {
    await apiRequestWrapper(async () => {
      const result = await searchReferences(query);
      setReferences(result);
    });
  };

  useEffect(() => {
    if (!preloadData) return;
    fetch({ limit: 10, page: 1 });
  }, []);

  return {
    references,
    refreshReferences: fetch,
    searchReferences: search,
    loadingReferences: loading,
  };
}
